
















import { DashboardService } from "@/services/dashboard.service";
import GlobalMixin from "@/shared/mixins/globalMixin";
import { Component, Mixins, Prop, Watch } from "vue-property-decorator";

@Component({
  
})
export default class PlanoExpiradoCard extends Mixins(GlobalMixin) {
  totalPlanosExpirados: number | null = null;
  loadingPlanos = false;
  status = 3;

  @Prop() readonly date!: string | null;

  mounted() {
    this.onChangeDate();
  }

  @Watch("date")
  onChangeDate() {
    this.CarregarPlanosExpirados();
  }

  async CarregarPlanosExpirados() {
    this.loadingPlanos = true;
    if (this.date) {
      this.totalPlanosExpirados = await DashboardService.PlanosExpirados(this.date, this.status).finally(
        () => (this.loadingPlanos = false)
      );
    }
  }
}
